// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 2.12.0 (commit 2f8905d6aaf3e9ffcbce3a8a1a1e30e715ad5db7).

/* eslint-disable */
/* tslint:disable */
import {
  DbConnectionBuilder as __DbConnectionBuilder,
  DbConnectionImpl as __DbConnectionImpl,
  SubscriptionBuilderImpl as __SubscriptionBuilderImpl,
  TypeBuilder as __TypeBuilder,
  Uuid as __Uuid,
  convertToAccessorMap as __convertToAccessorMap,
  makeQueryBuilder as __makeQueryBuilder,
  procedureSchema as __procedureSchema,
  procedures as __procedures,
  reducerSchema as __reducerSchema,
  reducers as __reducers,
  schema as __schema,
  t as __t,
  table as __table,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type DbConnectionConfig as __DbConnectionConfig,
  type ErrorContextInterface as __ErrorContextInterface,
  type Event as __Event,
  type EventContextInterface as __EventContextInterface,
  type Infer as __Infer,
  type QueryBuilder as __QueryBuilder,
  type ReducerEventContextInterface as __ReducerEventContextInterface,
  type RemoteModule as __RemoteModule,
  type SubscriptionEventContextInterface as __SubscriptionEventContextInterface,
  type SubscriptionHandleImpl as __SubscriptionHandleImpl,
} from "spacetimedb";

// Import all reducer arg schemas
import AcceptBrandInviteReducer from "./accept_brand_invite_reducer";
import AcknowledgeMessageReducer from "./acknowledge_message_reducer";
import AddTargetablePropertyForBrandReducer from "./add_targetable_property_for_brand_reducer";
import AdminDeleteTtwPageReducer from "./admin_delete_ttw_page_reducer";
import AdminRepointBrandTargetablePropertyReducer from "./admin_repoint_brand_targetable_property_reducer";
import AdminSetBrandCoordinatesReducer from "./admin_set_brand_coordinates_reducer";
import AdminSetNominationCoordinatesReducer from "./admin_set_nomination_coordinates_reducer";
import AdminSetTargetablePropertyCoordinatesReducer from "./admin_set_targetable_property_coordinates_reducer";
import AdminUpdateTargetablePropertyReducer from "./admin_update_targetable_property_reducer";
import AdminUpdateTtwPageReducer from "./admin_update_ttw_page_reducer";
import AdminUpdateUnderwritingQuestionReducer from "./admin_update_underwriting_question_reducer";
import ApproveComparablePropertyReducer from "./approve_comparable_property_reducer";
import ClaimNominationReducer from "./claim_nomination_reducer";
import ConfirmBusinessDetailsReducer from "./confirm_business_details_reducer";
import ConfirmOperatingLocationsReducer from "./confirm_operating_locations_reducer";
import CreateInvestorReducer from "./create_investor_reducer";
import CreateSmbReducer from "./create_smb_reducer";
import CustomizeStylingReducer from "./customize_styling_reducer";
import DeclineBrandInviteReducer from "./decline_brand_invite_reducer";
import DeleteE2ENominationsByNameReducer from "./delete_e_2_e_nominations_by_name_reducer";
import ExpressInterestInNominationReducer from "./express_interest_in_nomination_reducer";
import InviteUserToBrandReducer from "./invite_user_to_brand_reducer";
import NominateBusinessReducer from "./nominate_business_reducer";
import RemoveBrandUserReducer from "./remove_brand_user_reducer";
import RemoveInterestInNominationReducer from "./remove_interest_in_nomination_reducer";
import ResetFetchCompsJobReducer from "./reset_fetch_comps_job_reducer";
import ResetFetchOperatingPropertiesJobReducer from "./reset_fetch_operating_properties_job_reducer";
import ResetUnderwritingResultsJobReducer from "./reset_underwriting_results_job_reducer";
import RevokeBrandInviteReducer from "./revoke_brand_invite_reducer";
import RunPendingMigrationsReducer from "./run_pending_migrations_reducer";
import SeedAboutYouReducer from "./seed_about_you_reducer";
import SeedBrowseNominationsReducer from "./seed_browse_nominations_reducer";
import SeedCommunityTheaterReducer from "./seed_community_theater_reducer";
import SeedConnectAccountingForEntityReducer from "./seed_connect_accounting_for_entity_reducer";
import SeedDefaultDataReducer from "./seed_default_data_reducer";
import SeedE2ENominationReducer from "./seed_e_2_e_nomination_reducer";
import SeedNominationsReducer from "./seed_nominations_reducer";
import SeedOfferingsReducer from "./seed_offerings_reducer";
import SeedOrientationReducer from "./seed_orientation_reducer";
import SeedPriceEstimateForTargetReducer from "./seed_price_estimate_for_target_reducer";
import SeedResetOperatingLocationsJobForBrandReducer from "./seed_reset_operating_locations_job_for_brand_reducer";
import SeedScheduleCallForEntityReducer from "./seed_schedule_call_for_entity_reducer";
import SeedSharableBusinessCardsReducer from "./seed_sharable_business_cards_reducer";
import SeedTtwPagesReducer from "./seed_ttw_pages_reducer";
import SeedWithCompsReducer from "./seed_with_comps_reducer";
import SeedWithQuestionsReducer from "./seed_with_questions_reducer";
import SelectBusinessFromPlaceReducer from "./select_business_from_place_reducer";
import SelectBusinessManuallyReducer from "./select_business_manually_reducer";
import SetImageForNominationClaimReducer from "./set_image_for_nomination_claim_reducer";
import SetOfferingStatusReducer from "./set_offering_status_reducer";
import SetUserIntendedContributionForTargetablePropertyReducer from "./set_user_intended_contribution_for_targetable_property_reducer";
import SetUserMaxPriceForTargetablePropertyReducer from "./set_user_max_price_for_targetable_property_reducer";
import SkipClaimingNominationReducer from "./skip_claiming_nomination_reducer";
import SubmitSupplementalInfoReducer from "./submit_supplemental_info_reducer";
import SubmitUserInfoReducer from "./submit_user_info_reducer";
import TestArmTransactSyncCronReducer from "./test_arm_transact_sync_cron_reducer";
import TestForceOrderStatusReducer from "./test_force_order_status_reducer";
import TestSetFeatureFlagReducer from "./test_set_feature_flag_reducer";
import TestSetOfferingStatusReducer from "./test_set_offering_status_reducer";
import TestStartTransactSyncJobReducer from "./test_start_transact_sync_job_reducer";
import TestUpsertTransactEntityReducer from "./test_upsert_transact_entity_reducer";
import TestUpsertUserInfoAccreditationReducer from "./test_upsert_user_info_accreditation_reducer";
import UntargetPropertyForUwEntityReducer from "./untarget_property_for_uw_entity_reducer";
import UpdateSmbDashboardOrientationStatusReducer from "./update_smb_dashboard_orientation_status_reducer";
import UpsertFeatureFlagReducer from "./upsert_feature_flag_reducer";
import UpsertSecretReducer from "./upsert_secret_reducer";

// Import all procedure arg schemas
import * as AdminBrandSnapshotProcedure from "./admin_brand_snapshot_procedure";
import * as AdminBrowseRowsMissingCoordinatesProcedure from "./admin_browse_rows_missing_coordinates_procedure";
import * as AdminClaimNominationForBrandProcedure from "./admin_claim_nomination_for_brand_procedure";
import * as AdminClaimableNominationsProcedure from "./admin_claimable_nominations_procedure";
import * as AdminCreateInvitedBrandDraftProcedure from "./admin_create_invited_brand_draft_procedure";
import * as AdminDeleteUserInfoProcedure from "./admin_delete_user_info_procedure";
import * as AdminGetInvitedBrandDraftProcedure from "./admin_get_invited_brand_draft_procedure";
import * as AdminListBrandsProcedure from "./admin_list_brands_procedure";
import * as AdminListInvitedBrandDraftsProcedure from "./admin_list_invited_brand_drafts_procedure";
import * as AdminRepointAccountingConnectionProcedure from "./admin_repoint_accounting_connection_procedure";
import * as AdminResendInvitedBrandDraftEmailProcedure from "./admin_resend_invited_brand_draft_email_procedure";
import * as AdminRestartAccountingProcessingProcedure from "./admin_restart_accounting_processing_procedure";
import * as AdminRestartPlaidProcessingProcedure from "./admin_restart_plaid_processing_procedure";
import * as AdminRestartPosProcessingProcedure from "./admin_restart_pos_processing_procedure";
import * as AdminRestartTaxReturnProcessingProcedure from "./admin_restart_tax_return_processing_procedure";
import * as AdminRetriggerLeaseDocProcessingProcedure from "./admin_retrigger_lease_doc_processing_procedure";
import * as AdminRevokeInvitedBrandDraftProcedure from "./admin_revoke_invited_brand_draft_procedure";
import * as AdminUpdateShareableBusinessCardAccessCodeProcedure from "./admin_update_shareable_business_card_access_code_procedure";
import * as AdminUpsertUserInfoProcedure from "./admin_upsert_user_info_procedure";
import * as BackfillShareableBusinessCardsBrowsableProcedure from "./backfill_shareable_business_cards_browsable_procedure";
import * as BeginInvitedBrandOnboardingProcedure from "./begin_invited_brand_onboarding_procedure";
import * as CompleteInvitedBrandOnboardingProcedure from "./complete_invited_brand_onboarding_procedure";
import * as ConnectAccountingProcedure from "./connect_accounting_procedure";
import * as ConnectMergeProcedure from "./connect_merge_procedure";
import * as ConnectPlaidProcedure from "./connect_plaid_procedure";
import * as ConnectPosProcedure from "./connect_pos_procedure";
import * as CreateAvatarUploadUrlProcedure from "./create_avatar_upload_url_procedure";
import * as CreateCalendlyBookingProcedure from "./create_calendly_booking_procedure";
import * as CreateComposerAssetUploadUrlProcedure from "./create_composer_asset_upload_url_procedure";
import * as CreateHeroUploadUrlProcedure from "./create_hero_upload_url_procedure";
import * as CreateInvestorTransactAccountProcedure from "./create_investor_transact_account_procedure";
import * as CreateLeaseDocUploadUrlProcedure from "./create_lease_doc_upload_url_procedure";
import * as CreateLeaseGraderUploadUrlProcedure from "./create_lease_grader_upload_url_procedure";
import * as CreateLinkTokenProcedure from "./create_link_token_procedure";
import * as CreateMergeLinkTokenProcedure from "./create_merge_link_token_procedure";
import * as CreateNominationHeroUploadUrlProcedure from "./create_nomination_hero_upload_url_procedure";
import * as CreateShareableBusinessCardProcedure from "./create_shareable_business_card_procedure";
import * as CreateTaxReturnUploadUrlProcedure from "./create_tax_return_upload_url_procedure";
import * as CreateTransactAccountProcedure from "./create_transact_account_procedure";
import * as CreateTransactEntityProcedure from "./create_transact_entity_procedure";
import * as CreateTransactLinkProcedure from "./create_transact_link_procedure";
import * as CreateTransactOfferingProcedure from "./create_transact_offering_procedure";
import * as CreateTransactPartyProcedure from "./create_transact_party_procedure";
import * as CreateTransactTradeProcedure from "./create_transact_trade_procedure";
import * as ExpressInterestInBusinessCardProcedure from "./express_interest_in_business_card_procedure";
import * as FinalizeHeroAndCustomizeStylingProcedure from "./finalize_hero_and_customize_styling_procedure";
import * as GenerateComposerPageProcedure from "./generate_composer_page_procedure";
import * as GetComposerChatProcedure from "./get_composer_chat_procedure";
import * as GetComposerPageProcedure from "./get_composer_page_procedure";
import * as GetComposerPageTestimonialsProcedure from "./get_composer_page_testimonials_procedure";
import * as GetLandlordNegotiationFormProcedure from "./get_landlord_negotiation_form_procedure";
import * as GetLeaseGraderChatProcedure from "./get_lease_grader_chat_procedure";
import * as GetMyComposerPageProcedure from "./get_my_composer_page_procedure";
import * as GetMyTtwPageProcedure from "./get_my_ttw_page_procedure";
import * as GetShareableBusinessCardProcedure from "./get_shareable_business_card_procedure";
import * as GetTtwPageProcedure from "./get_ttw_page_procedure";
import * as GetTtwPageBackersProcedure from "./get_ttw_page_backers_procedure";
import * as GradeLeaseProcedure from "./grade_lease_procedure";
import * as IngestLeaseDocsFromWebhookProcedure from "./ingest_lease_docs_from_webhook_procedure";
import * as LinkExternalAccountProcedure from "./link_external_account_procedure";
import * as PromoteTtwPageToOfferingProcedure from "./promote_ttw_page_to_offering_procedure";
import * as PublicOfferingForCardProcedure from "./public_offering_for_card_procedure";
import * as RemoveInterestInBusinessCardProcedure from "./remove_interest_in_business_card_procedure";
import * as RequestAppraisalForPropertyProcedure from "./request_appraisal_for_property_procedure";
import * as RequestLeaseDocsViaEmailProcedure from "./request_lease_docs_via_email_procedure";
import * as ResolveLeaseUploadCodeProcedure from "./resolve_lease_upload_code_procedure";
import * as SaveComposerPageProcedure from "./save_composer_page_procedure";
import * as SaveTtwPageProcedure from "./save_ttw_page_procedure";
import * as SearchNominationsProcedure from "./search_nominations_procedure";
import * as SendLandlordNegotiationInvitationProcedure from "./send_landlord_negotiation_invitation_procedure";
import * as SetInterestInBusinessCardProcedure from "./set_interest_in_business_card_procedure";
import * as SetTopThreeCompsProcedure from "./set_top_three_comps_procedure";
import * as StartCalculatingCompsForTargetablePropertyProcedure from "./start_calculating_comps_for_targetable_property_procedure";
import * as SubmitExternalFundMoveProcedure from "./submit_external_fund_move_procedure";
import * as SubmitLandlordNegotiationFormProcedure from "./submit_landlord_negotiation_form_procedure";
import * as SubmitLeaseDocProcedure from "./submit_lease_doc_procedure";
import * as SubmitLeaseGraderDocProcedure from "./submit_lease_grader_doc_procedure";
import * as SubmitNominationProcedure from "./submit_nomination_procedure";
import * as SubmitOrderProcedure from "./submit_order_procedure";
import * as SubmitTaxReturnProcedure from "./submit_tax_return_procedure";
import * as SubmitUnderwritingQuestionAnswerProcedure from "./submit_underwriting_question_answer_procedure";
import * as SyncTransactAccountProcedure from "./sync_transact_account_procedure";
import * as SyncTransactEntityProcedure from "./sync_transact_entity_procedure";
import * as SyncTransactLinkProcedure from "./sync_transact_link_procedure";
import * as SyncTransactOfferingProcedure from "./sync_transact_offering_procedure";
import * as SyncTransactPartyProcedure from "./sync_transact_party_procedure";
import * as SyncTransactTradeProcedure from "./sync_transact_trade_procedure";
import * as TargetPropertyForUwEntityProcedure from "./target_property_for_uw_entity_procedure";
import * as TestCreateInvestorTrioProcedure from "./test_create_investor_trio_procedure";
import * as TestLinkFundingSourceProcedure from "./test_link_funding_source_procedure";
import * as TestPromoteTtwPageToOfferingProcedure from "./test_promote_ttw_page_to_offering_procedure";
import * as TestRunOrderReconcileProcedure from "./test_run_order_reconcile_procedure";
import * as TestSubmitOrderProcedure from "./test_submit_order_procedure";
import * as TestUpdateOfferingTermsProcedure from "./test_update_offering_terms_procedure";
import * as UpdateInvitedOnboardingStepProcedure from "./update_invited_onboarding_step_procedure";
import * as UpdateOfferingTermsProcedure from "./update_offering_terms_procedure";
import * as UpdateShareableBusinessCardProcedure from "./update_shareable_business_card_procedure";
import * as UpdateTransactAccountProcedure from "./update_transact_account_procedure";
import * as UpdateTransactEntityProcedure from "./update_transact_entity_procedure";
import * as UpdateTransactOfferingProcedure from "./update_transact_offering_procedure";
import * as UpdateTransactPartyProcedure from "./update_transact_party_procedure";
import * as UpsertUserInfoProcedure from "./upsert_user_info_procedure";
import * as VerifyCatskillsExplorePasswordProcedure from "./verify_catskills_explore_password_procedure";

// Import all table schema definitions
import AdminAccountingConnectionsRow from "./admin_accounting_connections_table";
import AdminInvestorTransactAccountsRow from "./admin_investor_transact_accounts_table";
import AdminOfferingsRow from "./admin_offerings_table";
import AdminShareableBusinessCardsRow from "./admin_shareable_business_cards_table";
import AdminTargetablePropertiesRow from "./admin_targetable_properties_table";
import AdminTransactAccountsRow from "./admin_transact_accounts_table";
import AdminTransactFundMoveOpsRow from "./admin_transact_fund_move_ops_table";
import AdminTransactLinkOpsRow from "./admin_transact_link_ops_table";
import AdminTransactLinksRow from "./admin_transact_links_table";
import AdminTransactPartiesRow from "./admin_transact_parties_table";
import AdminTransactSyncJobsRow from "./admin_transact_sync_jobs_table";
import AdminTtwPagesRow from "./admin_ttw_pages_table";
import AdminUnderwritingQuestionsViewRow from "./admin_underwriting_questions_view_table";
import AdminUserInfoRow from "./admin_user_info_table";
import AllAccountingItemsForUserRow from "./all_accounting_items_for_user_table";
import AllBrandsForUserRow from "./all_brands_for_user_table";
import AllLeaseDocsForUserRow from "./all_lease_docs_for_user_table";
import AllMergeItemsForUserRow from "./all_merge_items_for_user_table";
import AllOperatingPropertiesForUserRow from "./all_operating_properties_for_user_table";
import AllPlaidItemsForUserRow from "./all_plaid_items_for_user_table";
import AllPosItemsForUserRow from "./all_pos_items_for_user_table";
import AllTargetablePropertiesForUserRow from "./all_targetable_properties_for_user_table";
import AllTaxReturnsForUserRow from "./all_tax_returns_for_user_table";
import AllUnderwritableEntitiesForUserRow from "./all_underwritable_entities_for_user_table";
import AppliedMigrationsRow from "./applied_migrations_table";
import BrandMembersRow from "./brand_members_table";
import CampaignBrowseNominationsRow from "./campaign_browse_nominations_table";
import CampaignBrowseShareableCardsRow from "./campaign_browse_shareable_cards_table";
import CardEngineInputsRow from "./card_engine_inputs_table";
import CommunityTheaterPledgesRow from "./community_theater_pledges_table";
import CurrentUserRow from "./current_user_table";
import CurrentUserInfoRow from "./current_user_info_table";
import FeatureFlagsViewRow from "./feature_flags_view_table";
import FirstMatchingNominationRow from "./first_matching_nomination_table";
import InvestorDashboardRow from "./investor_dashboard_table";
import MyBusinessCardInterestsRow from "./my_business_card_interests_table";
import MyFundingSourcesRow from "./my_funding_sources_table";
import MyNominationInterestsRow from "./my_nomination_interests_table";
import MyTransactAccountIdRow from "./my_transact_account_id_table";
import OperatingPropertiesJobStatusForUserRow from "./operating_properties_job_status_for_user_table";
import PendingInvitesForUserRow from "./pending_invites_for_user_table";
import SecretsViewRow from "./secrets_view_table";
import ShareBusinessCardContextsRow from "./share_business_card_contexts_table";
import SmbOnboardingRow from "./smb_onboarding_table";
import SmbSuperViewRow from "./smb_super_view_table";

/** Type-only namespace exports for generated type groups. */

/** The schema information for all tables in this module. This is defined the same was as the tables would have been defined in the server. */
const tablesSchema = __schema({
  adminUnderwritingQuestionsView: __table({
    name: 'adminUnderwritingQuestionsView',
    indexes: [
    ],
    constraints: [
    ],
  }, AdminUnderwritingQuestionsViewRow),
  adminAccountingConnections: __table({
    name: 'admin_accounting_connections',
    indexes: [
    ],
    constraints: [
    ],
  }, AdminAccountingConnectionsRow),
  adminInvestorTransactAccounts: __table({
    name: 'admin_investor_transact_accounts',
    indexes: [
    ],
    constraints: [
    ],
  }, AdminInvestorTransactAccountsRow),
  adminOfferings: __table({
    name: 'admin_offerings',
    indexes: [
    ],
    constraints: [
    ],
  }, AdminOfferingsRow),
  adminShareableBusinessCards: __table({
    name: 'admin_shareable_business_cards',
    indexes: [
    ],
    constraints: [
    ],
  }, AdminShareableBusinessCardsRow),
  adminTargetableProperties: __table({
    name: 'admin_targetable_properties',
    indexes: [
    ],
    constraints: [
    ],
  }, AdminTargetablePropertiesRow),
  adminTransactAccounts: __table({
    name: 'admin_transact_accounts',
    indexes: [
    ],
    constraints: [
    ],
  }, AdminTransactAccountsRow),
  adminTransactFundMoveOps: __table({
    name: 'admin_transact_fund_move_ops',
    indexes: [
    ],
    constraints: [
    ],
  }, AdminTransactFundMoveOpsRow),
  adminTransactLinkOps: __table({
    name: 'admin_transact_link_ops',
    indexes: [
    ],
    constraints: [
    ],
  }, AdminTransactLinkOpsRow),
  adminTransactLinks: __table({
    name: 'admin_transact_links',
    indexes: [
    ],
    constraints: [
    ],
  }, AdminTransactLinksRow),
  adminTransactParties: __table({
    name: 'admin_transact_parties',
    indexes: [
    ],
    constraints: [
    ],
  }, AdminTransactPartiesRow),
  adminTransactSyncJobs: __table({
    name: 'admin_transact_sync_jobs',
    indexes: [
    ],
    constraints: [
    ],
  }, AdminTransactSyncJobsRow),
  adminTtwPages: __table({
    name: 'admin_ttw_pages',
    indexes: [
    ],
    constraints: [
    ],
  }, AdminTtwPagesRow),
  adminUserInfo: __table({
    name: 'admin_user_info',
    indexes: [
    ],
    constraints: [
    ],
  }, AdminUserInfoRow),
  allAccountingItemsForUser: __table({
    name: 'all_accounting_items_for_user',
    indexes: [
    ],
    constraints: [
    ],
  }, AllAccountingItemsForUserRow),
  allBrandsForUser: __table({
    name: 'all_brands_for_user',
    indexes: [
    ],
    constraints: [
    ],
  }, AllBrandsForUserRow),
  allLeaseDocsForUser: __table({
    name: 'all_lease_docs_for_user',
    indexes: [
    ],
    constraints: [
    ],
  }, AllLeaseDocsForUserRow),
  allMergeItemsForUser: __table({
    name: 'all_merge_items_for_user',
    indexes: [
    ],
    constraints: [
    ],
  }, AllMergeItemsForUserRow),
  allOperatingPropertiesForUser: __table({
    name: 'all_operating_properties_for_user',
    indexes: [
    ],
    constraints: [
    ],
  }, AllOperatingPropertiesForUserRow),
  allPlaidItemsForUser: __table({
    name: 'all_plaid_items_for_user',
    indexes: [
    ],
    constraints: [
    ],
  }, AllPlaidItemsForUserRow),
  allPosItemsForUser: __table({
    name: 'all_pos_items_for_user',
    indexes: [
    ],
    constraints: [
    ],
  }, AllPosItemsForUserRow),
  allTargetablePropertiesForUser: __table({
    name: 'all_targetable_properties_for_user',
    indexes: [
    ],
    constraints: [
    ],
  }, AllTargetablePropertiesForUserRow),
  allTaxReturnsForUser: __table({
    name: 'all_tax_returns_for_user',
    indexes: [
    ],
    constraints: [
    ],
  }, AllTaxReturnsForUserRow),
  allUnderwritableEntitiesForUser: __table({
    name: 'all_underwritable_entities_for_user',
    indexes: [
    ],
    constraints: [
    ],
  }, AllUnderwritableEntitiesForUserRow),
  appliedMigrations: __table({
    name: 'applied_migrations',
    indexes: [
    ],
    constraints: [
    ],
  }, AppliedMigrationsRow),
  brandMembers: __table({
    name: 'brand_members',
    indexes: [
    ],
    constraints: [
    ],
  }, BrandMembersRow),
  campaignBrowseNominations: __table({
    name: 'campaign_browse_nominations',
    indexes: [
    ],
    constraints: [
    ],
  }, CampaignBrowseNominationsRow),
  campaignBrowseShareableCards: __table({
    name: 'campaign_browse_shareable_cards',
    indexes: [
    ],
    constraints: [
    ],
  }, CampaignBrowseShareableCardsRow),
  cardEngineInputs: __table({
    name: 'card_engine_inputs',
    indexes: [
    ],
    constraints: [
    ],
  }, CardEngineInputsRow),
  communityTheaterPledges: __table({
    name: 'community_theater_pledges',
    indexes: [
    ],
    constraints: [
    ],
  }, CommunityTheaterPledgesRow),
  currentUser: __table({
    name: 'current_user',
    indexes: [
    ],
    constraints: [
    ],
  }, CurrentUserRow),
  currentUserInfo: __table({
    name: 'current_user_info',
    indexes: [
    ],
    constraints: [
    ],
  }, CurrentUserInfoRow),
  featureFlagsView: __table({
    name: 'featureFlagsView',
    indexes: [
    ],
    constraints: [
    ],
  }, FeatureFlagsViewRow),
  firstMatchingNomination: __table({
    name: 'first_matching_nomination',
    indexes: [
    ],
    constraints: [
    ],
  }, FirstMatchingNominationRow),
  investorDashboard: __table({
    name: 'investor_dashboard',
    indexes: [
    ],
    constraints: [
    ],
  }, InvestorDashboardRow),
  myBusinessCardInterests: __table({
    name: 'my_business_card_interests',
    indexes: [
    ],
    constraints: [
    ],
  }, MyBusinessCardInterestsRow),
  myFundingSources: __table({
    name: 'my_funding_sources',
    indexes: [
    ],
    constraints: [
    ],
  }, MyFundingSourcesRow),
  myNominationInterests: __table({
    name: 'my_nomination_interests',
    indexes: [
    ],
    constraints: [
    ],
  }, MyNominationInterestsRow),
  myTransactAccountId: __table({
    name: 'my_transact_account_id',
    indexes: [
    ],
    constraints: [
    ],
  }, MyTransactAccountIdRow),
  operatingPropertiesJobStatusForUser: __table({
    name: 'operating_properties_job_status_for_user',
    indexes: [
    ],
    constraints: [
    ],
  }, OperatingPropertiesJobStatusForUserRow),
  pendingInvitesForUser: __table({
    name: 'pending_invites_for_user',
    indexes: [
    ],
    constraints: [
    ],
  }, PendingInvitesForUserRow),
  secretsView: __table({
    name: 'secretsView',
    indexes: [
    ],
    constraints: [
    ],
  }, SecretsViewRow),
  shareBusinessCardContexts: __table({
    name: 'share_business_card_contexts',
    indexes: [
    ],
    constraints: [
    ],
  }, ShareBusinessCardContextsRow),
  smbOnboarding: __table({
    name: 'smb_onboarding',
    indexes: [
    ],
    constraints: [
    ],
  }, SmbOnboardingRow),
  smbSuperView: __table({
    name: 'smb_super_view',
    indexes: [
    ],
    constraints: [
    ],
  }, SmbSuperViewRow),
});

/** The schema information for all reducers in this module. This is defined the same way as the reducers would have been defined in the server, except the body of the reducer is omitted in code generation. */
const reducersSchema = __reducers(
  __reducerSchema("acceptBrandInvite", AcceptBrandInviteReducer),
  __reducerSchema("acknowledgeMessage", AcknowledgeMessageReducer),
  __reducerSchema("addTargetablePropertyForBrand", AddTargetablePropertyForBrandReducer),
  __reducerSchema("admin_delete_ttw_page", AdminDeleteTtwPageReducer),
  __reducerSchema("admin_repoint_brand_targetable_property", AdminRepointBrandTargetablePropertyReducer),
  __reducerSchema("adminSetBrandCoordinates", AdminSetBrandCoordinatesReducer),
  __reducerSchema("adminSetNominationCoordinates", AdminSetNominationCoordinatesReducer),
  __reducerSchema("adminSetTargetablePropertyCoordinates", AdminSetTargetablePropertyCoordinatesReducer),
  __reducerSchema("admin_update_targetable_property", AdminUpdateTargetablePropertyReducer),
  __reducerSchema("admin_update_ttw_page", AdminUpdateTtwPageReducer),
  __reducerSchema("adminUpdateUnderwritingQuestion", AdminUpdateUnderwritingQuestionReducer),
  __reducerSchema("approve_comparable_property", ApproveComparablePropertyReducer),
  __reducerSchema("claimNomination", ClaimNominationReducer),
  __reducerSchema("confirmBusinessDetails", ConfirmBusinessDetailsReducer),
  __reducerSchema("confirmOperatingLocations", ConfirmOperatingLocationsReducer),
  __reducerSchema("createInvestor", CreateInvestorReducer),
  __reducerSchema("createSmb", CreateSmbReducer),
  __reducerSchema("customizeStyling", CustomizeStylingReducer),
  __reducerSchema("declineBrandInvite", DeclineBrandInviteReducer),
  __reducerSchema("delete_e2e_nominations_by_name", DeleteE2ENominationsByNameReducer),
  __reducerSchema("expressInterestInNomination", ExpressInterestInNominationReducer),
  __reducerSchema("inviteUserToBrand", InviteUserToBrandReducer),
  __reducerSchema("nominateBusiness", NominateBusinessReducer),
  __reducerSchema("removeBrandUser", RemoveBrandUserReducer),
  __reducerSchema("removeInterestInNomination", RemoveInterestInNominationReducer),
  __reducerSchema("reset_fetch_comps_job", ResetFetchCompsJobReducer),
  __reducerSchema("reset_fetch_operating_properties_job", ResetFetchOperatingPropertiesJobReducer),
  __reducerSchema("reset_underwriting_results_job", ResetUnderwritingResultsJobReducer),
  __reducerSchema("revokeBrandInvite", RevokeBrandInviteReducer),
  __reducerSchema("run_pending_migrations", RunPendingMigrationsReducer),
  __reducerSchema("seed_about_you", SeedAboutYouReducer),
  __reducerSchema("seed_browse_nominations", SeedBrowseNominationsReducer),
  __reducerSchema("seed_community_theater", SeedCommunityTheaterReducer),
  __reducerSchema("seed_connect_accounting_for_entity", SeedConnectAccountingForEntityReducer),
  __reducerSchema("seed_default_data", SeedDefaultDataReducer),
  __reducerSchema("seed_e2e_nomination", SeedE2ENominationReducer),
  __reducerSchema("seed_nominations", SeedNominationsReducer),
  __reducerSchema("seed_offerings", SeedOfferingsReducer),
  __reducerSchema("seed_orientation", SeedOrientationReducer),
  __reducerSchema("seed_price_estimate_for_target", SeedPriceEstimateForTargetReducer),
  __reducerSchema("seed_reset_operating_locations_job_for_brand", SeedResetOperatingLocationsJobForBrandReducer),
  __reducerSchema("seed_schedule_call_for_entity", SeedScheduleCallForEntityReducer),
  __reducerSchema("seed_sharable_business_cards", SeedSharableBusinessCardsReducer),
  __reducerSchema("seed_ttw_pages", SeedTtwPagesReducer),
  __reducerSchema("seed_with_comps", SeedWithCompsReducer),
  __reducerSchema("seed_with_questions", SeedWithQuestionsReducer),
  __reducerSchema("selectBusinessFromPlace", SelectBusinessFromPlaceReducer),
  __reducerSchema("selectBusinessManually", SelectBusinessManuallyReducer),
  __reducerSchema("setImageForNominationClaim", SetImageForNominationClaimReducer),
  __reducerSchema("set_offering_status", SetOfferingStatusReducer),
  __reducerSchema("set_user_intended_contribution_for_targetable_property", SetUserIntendedContributionForTargetablePropertyReducer),
  __reducerSchema("set_user_max_price_for_targetable_property", SetUserMaxPriceForTargetablePropertyReducer),
  __reducerSchema("skipClaimingNomination", SkipClaimingNominationReducer),
  __reducerSchema("submitSupplementalInfo", SubmitSupplementalInfoReducer),
  __reducerSchema("submitUserInfo", SubmitUserInfoReducer),
  __reducerSchema("test_arm_transact_sync_cron", TestArmTransactSyncCronReducer),
  __reducerSchema("test_force_order_status", TestForceOrderStatusReducer),
  __reducerSchema("test_set_feature_flag", TestSetFeatureFlagReducer),
  __reducerSchema("test_set_offering_status", TestSetOfferingStatusReducer),
  __reducerSchema("test_start_transact_sync_job", TestStartTransactSyncJobReducer),
  __reducerSchema("test_upsert_transact_entity", TestUpsertTransactEntityReducer),
  __reducerSchema("test_upsert_user_info_accreditation", TestUpsertUserInfoAccreditationReducer),
  __reducerSchema("untargetPropertyForUwEntity", UntargetPropertyForUwEntityReducer),
  __reducerSchema("updateSmbDashboardOrientationStatus", UpdateSmbDashboardOrientationStatusReducer),
  __reducerSchema("upsertFeatureFlag", UpsertFeatureFlagReducer),
  __reducerSchema("upsertSecret", UpsertSecretReducer),
);

/** The schema information for all procedures in this module. This is defined the same way as the procedures would have been defined in the server. */
const proceduresSchema = __procedures(
  __procedureSchema("admin_brand_snapshot", AdminBrandSnapshotProcedure.params, AdminBrandSnapshotProcedure.returnType),
  __procedureSchema("admin_browse_rows_missing_coordinates", AdminBrowseRowsMissingCoordinatesProcedure.params, AdminBrowseRowsMissingCoordinatesProcedure.returnType),
  __procedureSchema("admin_claim_nomination_for_brand", AdminClaimNominationForBrandProcedure.params, AdminClaimNominationForBrandProcedure.returnType),
  __procedureSchema("admin_claimable_nominations", AdminClaimableNominationsProcedure.params, AdminClaimableNominationsProcedure.returnType),
  __procedureSchema("admin_create_invited_brand_draft", AdminCreateInvitedBrandDraftProcedure.params, AdminCreateInvitedBrandDraftProcedure.returnType),
  __procedureSchema("admin_delete_user_info", AdminDeleteUserInfoProcedure.params, AdminDeleteUserInfoProcedure.returnType),
  __procedureSchema("admin_get_invited_brand_draft", AdminGetInvitedBrandDraftProcedure.params, AdminGetInvitedBrandDraftProcedure.returnType),
  __procedureSchema("admin_list_brands", AdminListBrandsProcedure.params, AdminListBrandsProcedure.returnType),
  __procedureSchema("admin_list_invited_brand_drafts", AdminListInvitedBrandDraftsProcedure.params, AdminListInvitedBrandDraftsProcedure.returnType),
  __procedureSchema("admin_repoint_accounting_connection", AdminRepointAccountingConnectionProcedure.params, AdminRepointAccountingConnectionProcedure.returnType),
  __procedureSchema("admin_resend_invited_brand_draft_email", AdminResendInvitedBrandDraftEmailProcedure.params, AdminResendInvitedBrandDraftEmailProcedure.returnType),
  __procedureSchema("admin_restart_accounting_processing", AdminRestartAccountingProcessingProcedure.params, AdminRestartAccountingProcessingProcedure.returnType),
  __procedureSchema("admin_restart_plaid_processing", AdminRestartPlaidProcessingProcedure.params, AdminRestartPlaidProcessingProcedure.returnType),
  __procedureSchema("admin_restart_pos_processing", AdminRestartPosProcessingProcedure.params, AdminRestartPosProcessingProcedure.returnType),
  __procedureSchema("admin_restart_tax_return_processing", AdminRestartTaxReturnProcessingProcedure.params, AdminRestartTaxReturnProcessingProcedure.returnType),
  __procedureSchema("admin_retrigger_lease_doc_processing", AdminRetriggerLeaseDocProcessingProcedure.params, AdminRetriggerLeaseDocProcessingProcedure.returnType),
  __procedureSchema("admin_revoke_invited_brand_draft", AdminRevokeInvitedBrandDraftProcedure.params, AdminRevokeInvitedBrandDraftProcedure.returnType),
  __procedureSchema("admin_update_shareable_business_card_access_code", AdminUpdateShareableBusinessCardAccessCodeProcedure.params, AdminUpdateShareableBusinessCardAccessCodeProcedure.returnType),
  __procedureSchema("admin_upsert_user_info", AdminUpsertUserInfoProcedure.params, AdminUpsertUserInfoProcedure.returnType),
  __procedureSchema("backfill_shareable_business_cards_browsable", BackfillShareableBusinessCardsBrowsableProcedure.params, BackfillShareableBusinessCardsBrowsableProcedure.returnType),
  __procedureSchema("begin_invited_brand_onboarding", BeginInvitedBrandOnboardingProcedure.params, BeginInvitedBrandOnboardingProcedure.returnType),
  __procedureSchema("complete_invited_brand_onboarding", CompleteInvitedBrandOnboardingProcedure.params, CompleteInvitedBrandOnboardingProcedure.returnType),
  __procedureSchema("connect_accounting", ConnectAccountingProcedure.params, ConnectAccountingProcedure.returnType),
  __procedureSchema("connect_merge", ConnectMergeProcedure.params, ConnectMergeProcedure.returnType),
  __procedureSchema("connect_plaid", ConnectPlaidProcedure.params, ConnectPlaidProcedure.returnType),
  __procedureSchema("connect_pos", ConnectPosProcedure.params, ConnectPosProcedure.returnType),
  __procedureSchema("create_avatar_upload_url", CreateAvatarUploadUrlProcedure.params, CreateAvatarUploadUrlProcedure.returnType),
  __procedureSchema("create_calendly_booking", CreateCalendlyBookingProcedure.params, CreateCalendlyBookingProcedure.returnType),
  __procedureSchema("create_composer_asset_upload_url", CreateComposerAssetUploadUrlProcedure.params, CreateComposerAssetUploadUrlProcedure.returnType),
  __procedureSchema("create_hero_upload_url", CreateHeroUploadUrlProcedure.params, CreateHeroUploadUrlProcedure.returnType),
  __procedureSchema("create_investor_transact_account", CreateInvestorTransactAccountProcedure.params, CreateInvestorTransactAccountProcedure.returnType),
  __procedureSchema("create_lease_doc_upload_url", CreateLeaseDocUploadUrlProcedure.params, CreateLeaseDocUploadUrlProcedure.returnType),
  __procedureSchema("create_lease_grader_upload_url", CreateLeaseGraderUploadUrlProcedure.params, CreateLeaseGraderUploadUrlProcedure.returnType),
  __procedureSchema("create_link_token", CreateLinkTokenProcedure.params, CreateLinkTokenProcedure.returnType),
  __procedureSchema("create_merge_link_token", CreateMergeLinkTokenProcedure.params, CreateMergeLinkTokenProcedure.returnType),
  __procedureSchema("create_nomination_hero_upload_url", CreateNominationHeroUploadUrlProcedure.params, CreateNominationHeroUploadUrlProcedure.returnType),
  __procedureSchema("create_shareable_business_card", CreateShareableBusinessCardProcedure.params, CreateShareableBusinessCardProcedure.returnType),
  __procedureSchema("create_tax_return_upload_url", CreateTaxReturnUploadUrlProcedure.params, CreateTaxReturnUploadUrlProcedure.returnType),
  __procedureSchema("create_transact_account", CreateTransactAccountProcedure.params, CreateTransactAccountProcedure.returnType),
  __procedureSchema("create_transact_entity", CreateTransactEntityProcedure.params, CreateTransactEntityProcedure.returnType),
  __procedureSchema("create_transact_link", CreateTransactLinkProcedure.params, CreateTransactLinkProcedure.returnType),
  __procedureSchema("create_transact_offering", CreateTransactOfferingProcedure.params, CreateTransactOfferingProcedure.returnType),
  __procedureSchema("create_transact_party", CreateTransactPartyProcedure.params, CreateTransactPartyProcedure.returnType),
  __procedureSchema("create_transact_trade", CreateTransactTradeProcedure.params, CreateTransactTradeProcedure.returnType),
  __procedureSchema("express_interest_in_business_card", ExpressInterestInBusinessCardProcedure.params, ExpressInterestInBusinessCardProcedure.returnType),
  __procedureSchema("finalize_hero_and_customize_styling", FinalizeHeroAndCustomizeStylingProcedure.params, FinalizeHeroAndCustomizeStylingProcedure.returnType),
  __procedureSchema("generate_composer_page", GenerateComposerPageProcedure.params, GenerateComposerPageProcedure.returnType),
  __procedureSchema("get_composer_chat", GetComposerChatProcedure.params, GetComposerChatProcedure.returnType),
  __procedureSchema("get_composer_page", GetComposerPageProcedure.params, GetComposerPageProcedure.returnType),
  __procedureSchema("get_composer_page_testimonials", GetComposerPageTestimonialsProcedure.params, GetComposerPageTestimonialsProcedure.returnType),
  __procedureSchema("get_landlord_negotiation_form", GetLandlordNegotiationFormProcedure.params, GetLandlordNegotiationFormProcedure.returnType),
  __procedureSchema("get_lease_grader_chat", GetLeaseGraderChatProcedure.params, GetLeaseGraderChatProcedure.returnType),
  __procedureSchema("get_my_composer_page", GetMyComposerPageProcedure.params, GetMyComposerPageProcedure.returnType),
  __procedureSchema("get_my_ttw_page", GetMyTtwPageProcedure.params, GetMyTtwPageProcedure.returnType),
  __procedureSchema("get_shareable_business_card", GetShareableBusinessCardProcedure.params, GetShareableBusinessCardProcedure.returnType),
  __procedureSchema("get_ttw_page", GetTtwPageProcedure.params, GetTtwPageProcedure.returnType),
  __procedureSchema("get_ttw_page_backers", GetTtwPageBackersProcedure.params, GetTtwPageBackersProcedure.returnType),
  __procedureSchema("grade_lease", GradeLeaseProcedure.params, GradeLeaseProcedure.returnType),
  __procedureSchema("ingest_lease_docs_from_webhook", IngestLeaseDocsFromWebhookProcedure.params, IngestLeaseDocsFromWebhookProcedure.returnType),
  __procedureSchema("link_external_account", LinkExternalAccountProcedure.params, LinkExternalAccountProcedure.returnType),
  __procedureSchema("promote_ttw_page_to_offering", PromoteTtwPageToOfferingProcedure.params, PromoteTtwPageToOfferingProcedure.returnType),
  __procedureSchema("public_offering_for_card", PublicOfferingForCardProcedure.params, PublicOfferingForCardProcedure.returnType),
  __procedureSchema("remove_interest_in_business_card", RemoveInterestInBusinessCardProcedure.params, RemoveInterestInBusinessCardProcedure.returnType),
  __procedureSchema("request_appraisal_for_property", RequestAppraisalForPropertyProcedure.params, RequestAppraisalForPropertyProcedure.returnType),
  __procedureSchema("request_lease_docs_via_email", RequestLeaseDocsViaEmailProcedure.params, RequestLeaseDocsViaEmailProcedure.returnType),
  __procedureSchema("resolve_lease_upload_code", ResolveLeaseUploadCodeProcedure.params, ResolveLeaseUploadCodeProcedure.returnType),
  __procedureSchema("save_composer_page", SaveComposerPageProcedure.params, SaveComposerPageProcedure.returnType),
  __procedureSchema("save_ttw_page", SaveTtwPageProcedure.params, SaveTtwPageProcedure.returnType),
  __procedureSchema("search_nominations", SearchNominationsProcedure.params, SearchNominationsProcedure.returnType),
  __procedureSchema("send_landlord_negotiation_invitation", SendLandlordNegotiationInvitationProcedure.params, SendLandlordNegotiationInvitationProcedure.returnType),
  __procedureSchema("set_interest_in_business_card", SetInterestInBusinessCardProcedure.params, SetInterestInBusinessCardProcedure.returnType),
  __procedureSchema("set_top_three_comps", SetTopThreeCompsProcedure.params, SetTopThreeCompsProcedure.returnType),
  __procedureSchema("start_calculating_comps_for_targetable_property", StartCalculatingCompsForTargetablePropertyProcedure.params, StartCalculatingCompsForTargetablePropertyProcedure.returnType),
  __procedureSchema("submit_external_fund_move", SubmitExternalFundMoveProcedure.params, SubmitExternalFundMoveProcedure.returnType),
  __procedureSchema("submit_landlord_negotiation_form", SubmitLandlordNegotiationFormProcedure.params, SubmitLandlordNegotiationFormProcedure.returnType),
  __procedureSchema("submit_lease_doc", SubmitLeaseDocProcedure.params, SubmitLeaseDocProcedure.returnType),
  __procedureSchema("submit_lease_grader_doc", SubmitLeaseGraderDocProcedure.params, SubmitLeaseGraderDocProcedure.returnType),
  __procedureSchema("submit_nomination", SubmitNominationProcedure.params, SubmitNominationProcedure.returnType),
  __procedureSchema("submit_order", SubmitOrderProcedure.params, SubmitOrderProcedure.returnType),
  __procedureSchema("submit_tax_return", SubmitTaxReturnProcedure.params, SubmitTaxReturnProcedure.returnType),
  __procedureSchema("submit_underwriting_question_answer", SubmitUnderwritingQuestionAnswerProcedure.params, SubmitUnderwritingQuestionAnswerProcedure.returnType),
  __procedureSchema("sync_transact_account", SyncTransactAccountProcedure.params, SyncTransactAccountProcedure.returnType),
  __procedureSchema("sync_transact_entity", SyncTransactEntityProcedure.params, SyncTransactEntityProcedure.returnType),
  __procedureSchema("sync_transact_link", SyncTransactLinkProcedure.params, SyncTransactLinkProcedure.returnType),
  __procedureSchema("sync_transact_offering", SyncTransactOfferingProcedure.params, SyncTransactOfferingProcedure.returnType),
  __procedureSchema("sync_transact_party", SyncTransactPartyProcedure.params, SyncTransactPartyProcedure.returnType),
  __procedureSchema("sync_transact_trade", SyncTransactTradeProcedure.params, SyncTransactTradeProcedure.returnType),
  __procedureSchema("target_property_for_uw_entity", TargetPropertyForUwEntityProcedure.params, TargetPropertyForUwEntityProcedure.returnType),
  __procedureSchema("test_create_investor_trio", TestCreateInvestorTrioProcedure.params, TestCreateInvestorTrioProcedure.returnType),
  __procedureSchema("test_link_funding_source", TestLinkFundingSourceProcedure.params, TestLinkFundingSourceProcedure.returnType),
  __procedureSchema("test_promote_ttw_page_to_offering", TestPromoteTtwPageToOfferingProcedure.params, TestPromoteTtwPageToOfferingProcedure.returnType),
  __procedureSchema("test_run_order_reconcile", TestRunOrderReconcileProcedure.params, TestRunOrderReconcileProcedure.returnType),
  __procedureSchema("test_submit_order", TestSubmitOrderProcedure.params, TestSubmitOrderProcedure.returnType),
  __procedureSchema("test_update_offering_terms", TestUpdateOfferingTermsProcedure.params, TestUpdateOfferingTermsProcedure.returnType),
  __procedureSchema("update_invited_onboarding_step", UpdateInvitedOnboardingStepProcedure.params, UpdateInvitedOnboardingStepProcedure.returnType),
  __procedureSchema("update_offering_terms", UpdateOfferingTermsProcedure.params, UpdateOfferingTermsProcedure.returnType),
  __procedureSchema("update_shareable_business_card", UpdateShareableBusinessCardProcedure.params, UpdateShareableBusinessCardProcedure.returnType),
  __procedureSchema("update_transact_account", UpdateTransactAccountProcedure.params, UpdateTransactAccountProcedure.returnType),
  __procedureSchema("update_transact_entity", UpdateTransactEntityProcedure.params, UpdateTransactEntityProcedure.returnType),
  __procedureSchema("update_transact_offering", UpdateTransactOfferingProcedure.params, UpdateTransactOfferingProcedure.returnType),
  __procedureSchema("update_transact_party", UpdateTransactPartyProcedure.params, UpdateTransactPartyProcedure.returnType),
  __procedureSchema("upsert_user_info", UpsertUserInfoProcedure.params, UpsertUserInfoProcedure.returnType),
  __procedureSchema("verify_catskills_explore_password", VerifyCatskillsExplorePasswordProcedure.params, VerifyCatskillsExplorePasswordProcedure.returnType),
);

/** The remote SpacetimeDB module schema, both runtime and type information. */
const REMOTE_MODULE = {
  versionInfo: {
    cliVersion: "2.12.0" as const,
  },
  tables: tablesSchema.schemaType.tables,
  reducers: reducersSchema.reducersType.reducers,
  ...proceduresSchema,
} satisfies __RemoteModule<
  typeof tablesSchema.schemaType,
  typeof reducersSchema.reducersType,
  typeof proceduresSchema
>;

/** The tables available in this remote SpacetimeDB module. Each table reference doubles as a query builder. */
export const tables: __QueryBuilder<typeof tablesSchema.schemaType> = __makeQueryBuilder(tablesSchema.schemaType);

/** The reducers available in this remote SpacetimeDB module. */
export const reducers = __convertToAccessorMap(reducersSchema.reducersType.reducers);

/** The procedures available in this remote SpacetimeDB module. */
export const procedures = __convertToAccessorMap(proceduresSchema.procedures);

/** The context type returned in callbacks for all possible events. */
export type EventContext = __EventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for reducer events. */
export type ReducerEventContext = __ReducerEventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for subscription events. */
export type SubscriptionEventContext = __SubscriptionEventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for error events. */
export type ErrorContext = __ErrorContextInterface<typeof REMOTE_MODULE>;
/** The subscription handle type to manage active subscriptions created from a {@link SubscriptionBuilder}. */
export type SubscriptionHandle = __SubscriptionHandleImpl<typeof REMOTE_MODULE>;

/** Builder class to configure a new subscription to the remote SpacetimeDB instance. */
export class SubscriptionBuilder extends __SubscriptionBuilderImpl<typeof REMOTE_MODULE> {}

/** Builder class to configure a new database connection to the remote SpacetimeDB instance. */
export class DbConnectionBuilder extends __DbConnectionBuilder<DbConnection> {}

/** The typed database connection to manage connections to the remote SpacetimeDB instance. This class has type information specific to the generated module. */
export class DbConnection extends __DbConnectionImpl<typeof REMOTE_MODULE> {
  /** Creates a new {@link DbConnectionBuilder} to configure and connect to the remote SpacetimeDB instance. */
  static builder = (): DbConnectionBuilder => {
    return new DbConnectionBuilder(REMOTE_MODULE, (config: __DbConnectionConfig<typeof REMOTE_MODULE>) => new DbConnection(config));
  };

  /** Creates a new {@link SubscriptionBuilder} to configure a subscription to the remote SpacetimeDB instance. */
  override subscriptionBuilder = (): SubscriptionBuilder => {
    return new SubscriptionBuilder(this);
  };
}

